import React from "react";
import { Link } from "react-router-dom";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  breadCrumb: {
    fontSize: "13px",
    "& p.MuiTypography-root": {
      fontSize: "13px",
      color: "rgba(0, 0, 0, 0.87)",
      wordBreak: "break-all",
    },
    "& a.MuiTypography-root": { fontSize: "13px", wordBreak: "break-all" },
    "& a.MuiTypography-root:hover": { color: "rgba(0, 0, 0, 0.87)" },
  },
});

// Prepare Breadcrumb component
const Breadcrumb = ({ configData, loading }) => {
  const { classes } = useStyles();

  return !loading ? (
    <Breadcrumbs className={classes.breadCrumb} aria-label="breadcrumb" sx={{ flexGrow: 1 }} separator={"/"}>
      {configData.map((item, key) => {
        return item.active ? (
          <Typography key={key}>{item.displayName}</Typography>
        ) : (
          <Link key={key} to={item.link} className={"bread-crum-link"}>
            {item.displayName}
          </Link>
        );
      })}
    </Breadcrumbs>
  ) : null;
};

export default React.memo(Breadcrumb);
